module.exports = __webpack_public_path__ + "static/womanandchildtablet-caa1098f82f6466cf2480a2714928a93.jpg";